import { useSelector } from "react-redux";
import { selectIsAuth } from "../../store/slices/userSlice";

export const useAuth = () => {
  const isAuthenticated = useSelector(selectIsAuth);

  return isAuthenticated;
};
